<template>
  <el-dialog
    :title="title.text"
    class="dialog-edit"
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
    @close="cancelOperation('ruleForm')"
  >
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" size="small" label-width="125px" class="ruleForm-style">
      <el-form-item label="文章标题" prop="title">
        <el-input v-model="ruleForm.title" clearable placeholder="请填写文章标题" maxlength="255" />
      </el-form-item>
      <el-form-item label="文章类型:" prop="type">
        <template v-if="title.type=='add'">
          <el-select v-model="ruleForm.type">
            <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </template>
        <template v-else>
          <el-select v-model="ruleForm.type" disabled="disabled">
            <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </template>
      </el-form-item>
      <el-form-item label="文章内容" prop="content">
        <div>
          <quill-editor v-model="detailDesc" class='editor' ref="myQuillEditor" :options="editorOption"></quill-editor>
          <el-upload
            v-show="false"
            class="avatar-uploader-edit"
            :action="upload()"
            :show-file-list="false"
            accept=".jpg,.png,.jpeg"
            :before-upload="compressAndUpload"
            :on-success="handleSuccess"
          />
          </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancelOperation('ruleForm')">取 消</el-button>
      <el-button type="primary" @click="submitOperation('ruleForm')">提 交</el-button>
    </div>
  </el-dialog>
</template>
<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from "vue-quill-editor";
const titleConfig = [
  { Choice: '.ql-insertMetric', title: '跳转配置' },
  { Choice: '.ql-bold', title: '加粗' },
  { Choice: '.ql-italic', title: '斜体' },
  { Choice: '.ql-underline', title: '下划线' },
  { Choice: '.ql-header', title: '段落格式' },
  { Choice: '.ql-strike', title: '删除线' },
  { Choice: '.ql-blockquote', title: '块引用' },
  { Choice: '.ql-code', title: '插入代码' },
  { Choice: '.ql-code-block', title: '插入代码段' },
  { Choice: '.ql-font', title: '字体' },
  { Choice: '.ql-size', title: '字体大小' },
  { Choice: '.ql-list[value="ordered"]', title: '编号列表' },
  { Choice: '.ql-list[value="bullet"]', title: '项目列表' },
  { Choice: '.ql-direction', title: '文本方向' },
  { Choice: '.ql-header[value="1"]', title: 'h1' },
  { Choice: '.ql-header[value="2"]', title: 'h2' },
  { Choice: '.ql-align', title: '对齐方式' },
  { Choice: '.ql-color', title: '字体颜色' },
  { Choice: '.ql-background', title: '背景颜色' },
  { Choice: '.ql-image', title: '图像' },
  { Choice: '.ql-video', title: '视频' },
  { Choice: '.ql-link', title: '添加链接' },
  { Choice: '.ql-formula', title: '插入公式' },
  { Choice: '.ql-clean', title: '清除字体格式' },
  { Choice: '.ql-script[value="sub"]', title: '下标' },
  { Choice: '.ql-script[value="super"]', title: '上标' },
  { Choice: '.ql-indent[value="-1"]', title: '向左缩进' },
  { Choice: '.ql-indent[value="+1"]', title: '向右缩进' },
  { Choice: '.ql-header .ql-picker-label', title: '标题大小' },
  { Choice: '.ql-header .ql-picker-item[data-value="1"]', title: '标题一' },
  { Choice: '.ql-header .ql-picker-item[data-value="2"]', title: '标题二' },
  { Choice: '.ql-header .ql-picker-item[data-value="3"]', title: '标题三' },
  { Choice: '.ql-header .ql-picker-item[data-value="4"]', title: '标题四' },
  { Choice: '.ql-header .ql-picker-item[data-value="5"]', title: '标题五' },
  { Choice: '.ql-header .ql-picker-item[data-value="6"]', title: '标题六' },
  { Choice: '.ql-header .ql-picker-item:last-child', title: '标准' },
  { Choice: '.ql-size .ql-picker-item[data-value="small"]', title: '小号' },
  { Choice: '.ql-size .ql-picker-item[data-value="large"]', title: '大号' },
  { Choice: '.ql-size .ql-picker-item[data-value="huge"]', title: '超大号' },
  { Choice: '.ql-size .ql-picker-item:nth-child(2)', title: '标准' },
  { Choice: '.ql-align .ql-picker-item:first-child', title: '居左对齐' },
  { Choice: '.ql-align .ql-picker-item[data-value="center"]', title: '居中对齐' },
  { Choice: '.ql-align .ql-picker-item[data-value="right"]', title: '居右对齐' },
  { Choice: '.ql-align .ql-picker-item[data-value="justify"]', title: '两端对齐' }
]
import Quill from 'quill' // 引入编辑器
import ImageResize from 'quill-image-resize-module'; // 图片缩小放大插件
Quill.register('modules/imageResize', ImageResize);
// 自定义字体大小
const Size = Quill.import('attributors/style/size')
Size.whitelist = [ 
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "22px",
  "24px",
  "26px",
  "28px",
  "30px",
  "32px",
]
Quill.register(Size, true)
// 自定义字体类型
var fonts = [false,'SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'sans-serif']
var Font = Quill.import('formats/font')
Font.whitelist = fonts
Quill.register(Font, true)

import Parchment from 'parchment';
let config = {
  scope: Parchment.Scope.BLOCK,
  whitelist: ['right', 'center', 'justify']
};
let AlignStyle = new Parchment.Attributor.Style('align', 'text-align', config);
export { AlignStyle };

var Align = Quill.import('attributors/style/align');
Align.whitelist = ['right', 'center', 'justify'];
Quill.register(Align, true);

import conf from "@/config";
import Compressor from 'compressorjs';
export default {
  components: {
    quillEditor
  },
  name: 'ArticleDialogEditRow',
  data() {
    return {
      title: {
        type: '',
        text: ''
      },
      editorOption: {
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
              ['blockquote', 'code-block'], // 引用  代码块
              [{ list: 'ordered' }, { list: 'bullet' }], // 有序、无序列表
              [{ script: 'sub' }, { script: 'super' }], // 上标/下标
              [{ indent: '-1' }, { indent: '+1' }], // 缩进
              [{ direction: 'rtl' }], // 文本方向
              [{ size: Size.whitelist}], // 字体大小
              [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
              [{ font: [false,'SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial'] }], // 字体种类
              [{ align: [] }], // 对齐方式
              ['clean'], // 清除文本格式
              ['image'] // 链接、图片
            ],
            // 上传图片时，处理图片（图片压缩）
            handlers: {
              'image': function(value) {
                if (value) { // value === true
                  document.querySelector('.avatar-uploader-edit input').click()
                } else {
                  this.quill.format('image', false)
                }
              }
            }
          },
          imageResize: {
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white'
            },
            modules: [ 'Resize' ]
          },
        },
        placeholder: '请输入正文'
      },
      detailDesc:'',
      typeList: [],
      dialogFormVisible: false,
      ruleForm: {
        id: '',
        content: '',
        type: '',
        title: '',
      },
      rules: {
        title: [{ required: true, trigger: ['blur'], message: '请填写文章标题' }],
        type: [{ required: true, trigger: ['blur'], message: '请选择文章类型' }],
        content: [{ required: true, trigger: ['blur'], message: '文章内容不能为空' }],
      }
    }
  },
 
  methods: {
    async getTypes() {
      this.$get('admin/plat_message/type', {}).then(res => {
        this.typeList = res.list
      })
    },
    onEditorChange({ quill, html, text }) {
      this.detailDesc = html
    },
    compressAndUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
        return
      }
      return new Promise((resolve, reject) => {
        new Compressor(file, {
          quality: 0.2,
          convertSize: 500000, 
          success(result) {
            const newFile = new File([result], file.name, { type: file.type })
            resolve(newFile)
          },
          error(err) {
            reject(err)
          }
        })
      })
    },
    handleSuccess(res, file) {
      if (res.Data != "") {
        const quill = this.$refs.myQuillEditor.quill
        const length = quill.getSelection().index
        quill.insertEmbed(length, 'image', res.Data)
        quill.setSelection(length + 1)
      }
    },
    upload() {
      return conf.uploadApi + '/uploadToOss'
    },
    async dealDialog(optType = 'add', row = {}) {
      this.dialogFormVisible = true
      await this.getTypes()
      if (optType === 'add') {
        this.title = { type: optType, text: '新增文章' }
        this.ruleForm.content = ''
       
      } else if (optType === 'edit') {
        this.title = { type: optType, text: '编辑文章' }
        this.ruleForm = { ...row }
      }
      this.$nextTick(() => {

        for (let item of titleConfig) {
          let tip = document.querySelector('.quill-editor ' + item.Choice)
          if (!tip) continue
          tip.setAttribute('title', item.title)
        }
        this.detailDesc = this.ruleForm.content
        
      })
    },
    submitOperation(formName) {
      this.ruleForm.content =  this.detailDesc
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '数据请求中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          if (this.title.type === 'add') {
            let formData = new URLSearchParams()
            formData.append('content', this.ruleForm.content)
            formData.append("type", this.ruleForm.type)
            formData.append("title", this.ruleForm.title)
            this.$post('admin/plat_message/add', formData).then(res => {
              this.$message.success('添加成功')
              this.dialogFormVisible = false
              setTimeout(()=> {
                this.$emit('on-refresh')
              }, 800)
            })
            loading.close()
          } else if (this.title.type === 'edit') {
            let formData = new URLSearchParams()
            formData.append('content', this.ruleForm.content)
            formData.append("title", this.ruleForm.title)
            this.$post('admin/plat_message/edit/' + this.ruleForm.id, formData).then(res => {
              this.$message.success('编辑成功')
              this.dialogFormVisible = false
              setTimeout(()=> {
                this.$emit('on-refresh')
              }, 800)
            })
            loading.close()
          } else {
            loading.close()
            return false
          }
        } else {
          return false
        }
      })
    },
    cancelOperation(formName) {
      this.$refs[formName].resetFields()
      this[formName] = this.$options.data()[formName]
      this.dialogFormVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .quill-editor /deep/ .ql-container {
    min-height: 320px;
  }
 
  /deep/ {
    .ql-snow .ql-tooltip.ql-editing {
      left: 0 !important;
    }
 
    .ql-snow .ql-tooltip {
      left: 0 !important;
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="12px"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="12px"]::before {
      content: "12px";
    }
    
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="14px"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
      content: "14px";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="16px"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
      content: "16px";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="18px"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
      content: "18px";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="20px"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="20px"]::before {
      content: "20px";
    }
    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="22px"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="22px"]::before {
      content: "22px";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="24px"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="24px"]::before {
      content: "24px";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="26px"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="26px"]::before {
      content: "26px";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="28px"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="28px"]::before {
      content: "28px";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="30px"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="30px"]::before {
      content: "30px";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="32px"]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="32px"]::before {
      content: "32px";
    }
    
  
    .ql-snow .ql-picker.ql-font .ql-picker-label::before, .ql-snow .ql-picker.ql-font .ql-picker-item::before {
      content: "标准字体" !important;
    }

 
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="SimSun"]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="SimSun"]::before {
      content: "宋体" !important;
      font-family: "SimSun";
    }
 
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="SimHei"]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="SimHei"]::before {
      content: "黑体" !important;
      font-family: "SimHei";
    }
 
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Microsoft-YaHei"]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Microsoft-YaHei"]::before {
      content: "微软雅黑" !important;
      font-family: "Microsoft YaHei";
    }
 
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="KaiTi"]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="KaiTi"]::before {
      content: "楷体" !important;
      font-family: "KaiTi";
    }
 
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="FangSong"]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="FangSong"]::before {
      content: "仿宋" !important;
      font-family: "FangSong";
    }
 
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Arial"]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Arial"]::before {
      content: "Arial" !important;
      font-family: "Arial";
    }
 
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Times-New-Roman"]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Times-New-Roman"]::before {
      content: "Times New Roman" !important;
      font-family: "Times New Roman";
    }
 
    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="sans-serif"]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="sans-serif"]::before {
      content: "sans-serif" !important;
      font-family: "sans-serif";
    }
 
    .ql-font-SimSun {
      font-family: "SimSun";
    }
 
    .ql-font-SimHei {
      font-family: "SimHei";
    }
 
    .ql-font-Microsoft-YaHei {
      font-family: "Microsoft YaHei";
    }
 
    .ql-font-KaiTi {
      font-family: "KaiTi";
    }
 
    .ql-font-FangSong {
      font-family: "FangSong";
    }
 
    .ql-font-Arial {
      font-family: "Arial";
    }
 
    .ql-font-Times-New-Roman {
      font-family: "Times New Roman";
    }
 
    .ql-font-sans-serif {
      font-family: "sans-serif";
    }
 
    /*加上height和滚动属性就可以，滚动条样式是系统默认样式，可能不同*/
    .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
      border-color: #ccc;
      height: 125px;
      overflow: auto;
    }
    .ql-snow .ql-picker.ql-font {
      width: 96px !important;
    }
    .ql-snow .ql-picker.ql-size {
      width: 80px !important;
    }
  }
</style>
